export default "-- ClickBench Q5\nselect count(distinct searchphrase)\nfrom hits;";